import script from "./pointsRecharge.vue?vue&type=script&setup=true&lang=js"
export * from "./pointsRecharge.vue?vue&type=script&setup=true&lang=js"

import "./pointsRecharge.vue?vue&type=style&index=0&id=09ab74c4&lang=scss"

const __exports__ = script;

export default __exports__